import { useMediaQuery, useTheme } from '@mui/material';
import React, { FC } from 'react';

export const withDesktopView =
  <T,>(Component: FC<T>) =>
  ({ ...props }: T): JSX.Element | null => {
    const theme = useTheme();
    const isDesktopView = useMediaQuery(theme.breakpoints.up('lg'));

    if (!isDesktopView) {
      return null;
    }

    return <Component {...props} />;
  };
